(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["configurator-iframe"] && !Shopify.designMode) return;
  try {
    
  function addIframe(cartId) {
    // Get the parent element where you want to add the iframe
    const parentElement = document.getElementById('configurator-section');
    
    // Create the iframe element
    const iframeElement = document.createElement('iframe');

    iframeElement.id = "configurator"
    iframeElement.scrolling="no"
    //test
    // Set the source URL for the iframe
    iframeElement.src = 'http://vf-abp-dev-gc.ngrok.io/?mode=premade&product=' + '{{ settings.productKey }}' + '&cartId='+cartId
    
    // Set any other attributes you want for the iframe (e.g. width, height, etc.)
    iframeElement.width = '100%';
    iframeElement.height = '100%';
    iframeElement.setAttribute('frameborder', '0');
    
    // Append the iframe to the parent element
    parentElement.appendChild(iframeElement);
  }

  function getCartId() {
    var cookies = document.cookie.split("; ")
    var cartCookieString = cookies.find( x=> x.startsWith("cart="))
    if(cartCookieString) {
      var cartId = cartCookieString.split("=")[1]
      return cartId
    } else {
      return null
    }
  }
  
  var container = document.querySelector("#configurator-section")
  
  if(container) {
    var cartId = getCartId()
    if(cartId) {
      addIframe(cartId)
    } else {
      console.log("no cart")
      fetch('/cart.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          currency: 'USD'
        })
      })
      .then(() => {
        var cartId = getCartId()
        addIframe(cartId)
      })
      .catch(error => console.error('Error creating cart:', error));
    }
  } else {
    console.log("no container")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
